import { motion } from "framer-motion"
import { Button, ButtonProps } from "./button"
import { forwardRef } from "react"

interface AnimatedButtonProps extends ButtonProps {
  pulse?: boolean;
}

export const AnimatedButton = forwardRef<HTMLButtonElement, AnimatedButtonProps>(
  ({ children, pulse = false, ...props }, ref) => {
    return (
      <motion.div
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        transition={{
          type: "spring",
          stiffness: 400,
          damping: 17
        }}
        animate={pulse ? {
          scale: [1, 1.05, 1],
        } : {}}
        transition-duration={pulse ? 2 : 0}
      >
        <Button ref={ref} {...props}>
          {children}
        </Button>
      </motion.div>
    );
  }
);

AnimatedButton.displayName = "AnimatedButton";
